module.exports = __webpack_public_path__ + "static/img/services6.fe5d8b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services6.png
// module id = CDJ9
// module chunks = 0